import { render } from "./TitleBeltHistory.vue?vue&type=template&id=51631c65&scoped=true&bindings={}"
import script from "./TitleBeltHistory.vue?vue&type=script&lang=ts"
export * from "./TitleBeltHistory.vue?vue&type=script&lang=ts"

import "./TitleBeltHistory.vue?vue&type=style&index=0&id=51631c65&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51631c65"

export default script